import axios from "axios";
import { ApiError } from "../../Models/ApiError";
import { HandleError } from "../../Helpers/ErrorHandler";
import { OrderList } from "../../Models/OrderList";
import { Order } from "../../Models/Order";
import { PickCompleteRequest } from "../../Models/PickCompleteRequest";
import { LockUnlockResponse } from "../../Models/LockUnlockResponse";
import { ChangeStatusRequest } from "../../Models/ChangeStatusRequest";
import { TransHeaderResponse } from "../../Models/TransHeaderResponse";
import { SaveBoxListRequest } from "../../Models/SaveBoxListRequest";
import { PrintResponse } from "../../Models/PrintResponse";
import { BooleanResponse } from "../../Models/BooleanResponse";
import { LockUnlockRequest } from "../../Models/LockUnlockRequest";
import { SetOrderStatusRequest } from "../../Models/SetOrderStatusRequest";

const API_URL = process.env.REACT_APP_API_URL;

export const getExistingOrdersAPI = async (
  serverUrl: string,
  dbKey: string,
  showOnlyUnlocked: boolean = false,
  pickStatus: string = "",
  filterDays: number = 0,
  resultLimit: number = 0,
  orderGroup: string = "",
): Promise<OrderList> => {
  return new Promise<OrderList>((resolve, reject) => {
    let url = `${API_URL}order?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`;
    if (showOnlyUnlocked) {
      url += "&showOnlyUnlocked=true";
    }
    if (pickStatus) {
      url += `&pickStatus=${encodeURI(pickStatus)}`;
    }
    if (filterDays > 0) {
      url += `&filterDays=${filterDays}`;
    }
    if (resultLimit > 0) {
      url += `&resultLimit=${resultLimit}`;
    }
    if (orderGroup) {
      url += `&orderGroup=${encodeURI(orderGroup)}`;
    }
    axios
      .get<OrderList>(url)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
export const getExistingOrdersForPickAPI = async (
  serverUrl: string,
  dbKey: string,
  showOnlyUnlocked: boolean = false,
  pickStatus: string = "",
  filterDays: number = 0,
  resultLimit: number = 0,
  orderGroup: string = "",
): Promise<OrderList> => {
  return new Promise<OrderList>((resolve, reject) => {
    let url = `${API_URL}order/pick?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`;
    if (showOnlyUnlocked) {
      url += "&showOnlyUnlocked=true";
    }
    if (pickStatus) {
      url += `&pickStatus=${encodeURI(pickStatus)}`;
    }
    if (filterDays > 0) {
      url += `&filterDays=${filterDays}`;
    }
    if (resultLimit > 0) {
      url += `&resultLimit=${resultLimit}`;
    }
    if (orderGroup) {
      url += `&orderGroup=${encodeURI(orderGroup)}`;
    }
    axios
      .get<OrderList>(url)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
export const getExistingOrdersForQaAPI = async (serverUrl: string, dbKey: string): Promise<OrderList> => {
  return new Promise<OrderList>((resolve, reject) => {
    axios
      .get<OrderList>(`${API_URL}order/qa?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
export const getExistingOrdersForWrapAPI = async (serverUrl: string, dbKey: string): Promise<OrderList> => {
  return new Promise<OrderList>((resolve, reject) => {
    axios
      .get<OrderList>(`${API_URL}order/wrap?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
export const getExistingOrdersForDispatchAPI = async (serverUrl: string, dbKey: string): Promise<OrderList> => {
  return new Promise<OrderList>((resolve, reject) => {
    axios
      .get<OrderList>(`${API_URL}order/dispatch?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
export const getExistingOrdersForPackAPI = async (serverUrl: string, dbKey: string, packStatus: string = "", resultLimit: number = 0): Promise<OrderList> => {
  return new Promise<OrderList>((resolve, reject) => {
    let url = `${API_URL}order/pack?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`;
    if (packStatus) {
      url += `&packStatus=${encodeURI(packStatus)}`;
    }
    if (resultLimit > 0) {
      url += `&resultLimit=${resultLimit}`;
    }
    axios
      .get<OrderList>(url)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
export const getOrderDetailsAPI = async (transRefCode: string, serverUrl: string, dbKey: string, isForPack: boolean = false, isForPrePick: boolean = false): Promise<Order> => {
  return new Promise<Order>((resolve, reject) => {
    let url = `${API_URL}order/${transRefCode}?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`;
    if (isForPack) {
      url += "&isforpack=true";
    }
    if (isForPrePick) {
      url += "&isforprepick=true";
    }
    axios
      .get<Order>(url)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const getExistingOrdersForPrePickAPI = async (
  serverUrl: string,
  dbKey: string,
  showOnlyUnlocked: boolean = false,
  prePickStatus: string = "",
  filterDays: number = 0,
  resultLimit: number = 0,
  orderGroup: string = "",
): Promise<OrderList> => {
  return new Promise<OrderList>((resolve, reject) => {
    let url = `${API_URL}order/prepick?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`;
    if (showOnlyUnlocked) {
      url += "&showOnlyUnlocked=true";
    }
    if (prePickStatus) {
      url += `&prePickStatus=${encodeURI(prePickStatus)}`;
    }
    if (filterDays > 0) {
      url += `&filterDays=${filterDays}`;
    }
    if (resultLimit > 0) {
      url += `&resultLimit=${resultLimit}`;
    }
    if (orderGroup) {
      url += `&orderGroup=${encodeURI(orderGroup)}`;
    }
    axios
      .get<OrderList>(url)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
export const markOrderAsFullyPickedAPI = async (model: PickCompleteRequest, serverUrl: string, dbKey: string): Promise<boolean> => {
  return new Promise<boolean>((resolve, reject) => {
    axios
      .post<boolean>(`${API_URL}order/pickcomplete?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
export const setOrderQAStatusAPI = async (model: ChangeStatusRequest, serverUrl: string, dbKey: string): Promise<TransHeaderResponse> => {
  return new Promise<TransHeaderResponse>((resolve, reject) => {
    axios
      .post<TransHeaderResponse>(`${API_URL}order/qastatus?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
export const setOrderWrapStatusAPI = async (model: ChangeStatusRequest, serverUrl: string, dbKey: string): Promise<TransHeaderResponse> => {
  return new Promise<TransHeaderResponse>((resolve, reject) => {
    axios
      .post<TransHeaderResponse>(`${API_URL}order/wrapstatus?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
export const setOrderDispatchStatusAPI = async (model: ChangeStatusRequest, serverUrl: string, dbKey: string): Promise<TransHeaderResponse> => {
  return new Promise<TransHeaderResponse>((resolve, reject) => {
    axios
      .post<TransHeaderResponse>(`${API_URL}order/dispatchstatus?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
export const lockOrderAPI = async (model: LockUnlockRequest, serverUrl: string, dbKey: string): Promise<LockUnlockResponse> => {
  return new Promise<LockUnlockResponse>((resolve, reject) => {
    axios
      .post<LockUnlockResponse>(`${API_URL}order/lock?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const unlockOrderAPI = async (model: LockUnlockRequest, serverUrl: string, dbKey: string): Promise<LockUnlockResponse> => {
  return new Promise<LockUnlockResponse>((resolve, reject) => {
    axios
      .post<LockUnlockResponse>(`${API_URL}order/unlock?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const unlockAllOrdersAPI = async (serverUrl: string, dbKey: string): Promise<LockUnlockResponse> => {
  return new Promise<LockUnlockResponse>((resolve, reject) => {
    axios
      .post<LockUnlockResponse>(`${API_URL}order/unlockall?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const setOrderPendingStatusAPI = async (model: SetOrderStatusRequest, serverUrl: string, dbKey: string): Promise<TransHeaderResponse> => {
  return new Promise<TransHeaderResponse>((resolve, reject) => {
    axios
      .post<TransHeaderResponse>(`${API_URL}order/pendingstatus?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const saveBoxListAPI = async (model: SaveBoxListRequest, serverUrl: string, dbKey: string): Promise<TransHeaderResponse> => {
  return new Promise<TransHeaderResponse>((resolve, reject) => {
    axios
      .post<TransHeaderResponse>(`${API_URL}order/saveboxlist?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const isBoxedAPI = async (transRefCode: string, serverUrl: string, dbKey: string): Promise<BooleanResponse> => {
  return new Promise<BooleanResponse>((resolve, reject) => {
    axios
      .get<BooleanResponse>(`${API_URL}order/isboxed/${encodeURI(transRefCode)}?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const invoiceOrderAPI = async (transRefCode: string, serverUrl: string, dbKey: string): Promise<TransHeaderResponse> => {
  return new Promise<TransHeaderResponse>((resolve, reject) => {
    axios
      .post<TransHeaderResponse>(`${API_URL}order/invoice/${encodeURI(transRefCode)}?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const updateShippingAPI = async (transRefCode: string, serverUrl: string, dbKey: string): Promise<BooleanResponse> => {
  return new Promise<BooleanResponse>((resolve, reject) => {
    axios
      .post<BooleanResponse>(`${API_URL}order/updateshipping/${encodeURI(transRefCode)}?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const printAPI = async (transRefCode: string, serverUrl: string, dbKey: string): Promise<PrintResponse> => {
  return new Promise<PrintResponse>((resolve, reject) => {
    axios
      .post<PrintResponse>(`${API_URL}order/print/${encodeURI(transRefCode)}?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const getExistingTransactionsForTallyInAPI = async (
  serverUrl: string,
  dbKey: string,
  showOnlyUnlocked: boolean = false,
  filterDays: number = 0,
  resultLimit: number = 0,
  orderGroup: string = "",
  transType: string = "",
): Promise<OrderList> => {
  return new Promise<OrderList>((resolve, reject) => {
    let url = `${API_URL}order/tallyin?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`;
    if (showOnlyUnlocked) {
      url += "&showOnlyUnlocked=true";
    }
    if (filterDays > 0) {
      url += `&filterDays=${filterDays}`;
    }
    if (resultLimit > 0) {
      url += `&resultLimit=${resultLimit}`;
    }
    if (transType) {
      url += `&transType=${encodeURI(transType)}`;
    }
    if (orderGroup) {
      url += `&orderGroup=${encodeURI(orderGroup)}`;
    }
    axios
      .get<OrderList>(url)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const getTallyInTransactionDetailsAPI = async (transRefCode: string, serverUrl: string, dbKey: string, transType: string = ""): Promise<Order> => {
  return new Promise<Order>((resolve, reject) => {
    let url = `${API_URL}order/tallyin/${encodeURI(transRefCode)}?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`;
    if (transType) {
      url += `&transType=${encodeURI(transType)}`;
    }
    axios
      .get<Order>(url)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
